// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3miIV","content":"styles_content__Obovj"};